import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";

@Component({
  selector: "app-modal-previne-brasil-crianca",
  templateUrl: "./modal-previne-brasil-crianca.component.html",
  styleUrls: ["./modal-previne-brasil-crianca.component.css"],
})
export class ModalPrevineBrasilCriancaComponent implements OnInit {
  @Input() rotaApi?: string = "";
  @Input() listaDeRegistros: any[];
  @Input() tipoIndicador: string;
  loading: boolean = false;

  constructor(
    public global: Global,
    public service: ApiService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
 
  }

  limparCaracteresCidCiap(texto): string {
    if (texto !== undefined || texto.length > 1)
      return texto.slice(1, -1).replace(/\|/g, " - ");

    return " - ";
  }
  alternarExibicao(criterioSelecionado: any): void {
    this.listaDeRegistros.forEach((criterio) => {
      if (criterio === criterioSelecionado) {
        criterio.exibirTabela = !criterio.exibirTabela;
      } else {
        criterio.exibirTabela = false;
      }
    });
  }  
}
